import { useCallback, useEffect, useState } from "react";

import { elementLoadedInDOM } from "shared/helper-functions/dom/domHelpers";

export const defaultFixedHeaderHeight = 170;

export const useScroll = () => {
    const [fixedHeaderHeight, setFixedHeaderHeight] = useState(
        defaultFixedHeaderHeight
    );

    const handleScroll = useCallback(() => {

        const footerOffsetHeight = document.querySelector(".footer")?.offsetHeight;
        const dashBoardSelectorOffsetHeight = document.querySelector(".dashboard-selector")?.offsetHeight;
        const top = fixedHeaderHeight - (footerOffsetHeight + dashBoardSelectorOffsetHeight);
        
        const sideNav = document.querySelector(".sideNav");
        const linkTab = document.querySelector(".linkTabs");

        if (sideNav && linkTab) {
            if (globalThis.scrollY >= top) {
                sideNav.style.position = "fixed";
                sideNav.style.top = `${fixedHeaderHeight}px`;
                linkTab.style.marginLeft =
                    "calc(" +
                    sideNav?.offsetWidth +
                    "px" +
                    " + " +
                    "2rem" +
                    ")";
            } else {
                sideNav.style.position = "relative";
                sideNav.style.top = "0";
                linkTab.style.marginLeft = "0";
            }
        }
    }, [fixedHeaderHeight]);

    useEffect(() => {
        const init = async () => {
            await elementLoadedInDOM(".dashboard-selector");
            setFixedHeaderHeight(
                document.getElementById("top-nav").offsetHeight +
                document.querySelector(".selector-nav").offsetHeight
            );
        };
        init();
    }, []);

    useEffect(() => {
        globalThis.addEventListener("scroll", handleScroll);

        return () => {
            globalThis.removeEventListener("scroll", handleScroll);
        };
        
    }, [handleScroll]);

    return [fixedHeaderHeight];
};
